import { InputAdornment, TextField } from "@mui/material";

const TypeText = ({
  field,
  dataCollection,
  errors = {},
  updateValidationOnChange,
  size,
  onFocus,
  onBlur,
}) => {
  function handleTextChange(value) {
    updateValidationOnChange([field.key], value.target.value);
  }
  return (
    <TextField
      sx={{
        gridColumn: field.colspan
          ? `span ${field.colspan} / span ${field.colspan}`
          : "auto",
      }}
      size={size}
      label={field.label}
      value={dataCollection[field.key] || ""}
      onChange={handleTextChange}
      multiline={field.multiline ? true : false}
      error={Boolean(errors[field.key])}
      helperText={errors[field.key]}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">{field.unit}</InputAdornment>
        ),
      }}
      onFocus={onFocus}
      onBlur={onBlur}
      autoComplete={field.autoComplete ?? "on"}
    />
  );
};

export default TypeText;
